var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle (1) 1",
    clipPath: "url(#clip0_9307_20835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1318 4.36829C17.9597 2.19622 15.0718 1 12 1C8.92824 1 6.0403 2.19622 3.86824 4.36829C1.69618 6.54035 0.5 9.42824 0.5 12.5C0.5 15.5718 1.69622 18.4597 3.86824 20.6317C6.04026 22.8038 8.92824 24 12 24C15.0718 24 17.9597 22.8038 20.1318 20.6317C22.3038 18.4597 23.5 15.5718 23.5 12.5C23.5 9.42824 22.3038 6.54035 20.1318 4.36829ZM12 23.3262C6.03042 23.3262 1.17383 18.4696 1.17383 12.5C1.17383 6.53042 6.03042 1.67383 12 1.67383C17.9696 1.67383 22.8262 6.53042 22.8262 12.5C22.8262 18.4696 17.9696 23.3262 12 23.3262Z",
    fill: "#43FF61",
    stroke: "#43FF61",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1031 3.69531C10.0109 3.69531 7.98284 4.44236 6.39256 5.79882C6.25101 5.91957 6.23412 6.13223 6.35487 6.27378C6.47558 6.41533 6.68824 6.43227 6.82983 6.31147C8.29833 5.05896 10.1711 4.36914 12.1031 4.36914C16.5865 4.36914 20.234 8.01662 20.234 12.5C20.234 16.9834 16.5865 20.6309 12.1031 20.6309C7.61974 20.6309 3.97226 16.9834 3.97226 12.5C3.97226 10.568 4.66203 8.69521 5.91459 7.22676C6.03534 7.08521 6.0185 6.87255 5.8769 6.7518C5.73531 6.631 5.52265 6.64794 5.40194 6.78949C4.04548 8.37977 3.29843 10.4078 3.29843 12.5C3.29843 17.3549 7.24819 21.3047 12.1031 21.3047C16.9581 21.3047 20.9078 17.3549 20.9078 12.5C20.9078 7.64507 16.9581 3.69531 12.1031 3.69531Z",
    fill: "#43FF61",
    stroke: "#43FF61",
    strokeWidth: 0.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9307_20835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle1);
export default __webpack_public_path__ + "static/media/circle 1.09f5761ecc3f72c273f3fccc1fbfc224.svg";
export { ForwardRef as ReactComponent };